<template>
  <card>
    <h4 slot="header" v-if="result" class="card-title text-center">{{result}}</h4>
    <form>
      <div class="row">
        <div class="col-md-4">
          <base-input type="text" label="Name" placeholder="Name" v-model="client.name" :disabled="loading">
          </base-input>
        </div>
      </div>
      <div class="text-center">
        <button v-if="!loading && client.name" type="submit" class="btn btn-info btn-fill float-right" @click.prevent="createClient">
          Create Client
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

  export default {
    components: {
      Card
    },
    data () {
      return {
        loading: false,
        result: '',
        client: {
          name: '',
        }
      }
    },
    methods: {
      async createClient () {
        try {
          this.loading = true
          const app = getApp()
          const functions = getFunctions(app, 'europe-west1')
          // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
          const createClient = httpsCallable(functions, 'createClient');
          await createClient(this.client)
          this.result = 'Client Created Successfully'
        } catch (error) {
          this.result = 'Error: ' + error
        } finally {
          this.loading = false;
        }
      }
    }
  }

</script>
<style>

</style>
